import { render, staticRenderFns } from "./CardRoom3.vue?vue&type=template&id=47b499c6&scoped=true"
import script from "./CardRoom3.vue?vue&type=script&lang=js"
export * from "./CardRoom3.vue?vue&type=script&lang=js"
import style0 from "./CardRoom3.vue?vue&type=style&index=0&id=47b499c6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b499c6",
  null
  
)

export default component.exports